'use strict'
import { App } from '../../config/app.js'
import { Modal } from '../../modal.js'

export default function ()
{
	App.Modal.WalletCardSelect = new Modal('WalletCardSelect',
	{
		onOpen: async (modal, data) =>
		{
			return App.Store
				.page('walletcard', 1, 10)
				.catch(err => App.Component.HandleErrors(err))
				.finally(() =>
				{
					modal.view.model.clear()
					modal.view.model.sync(data)
				})
		}
	})

	//App.Action.create({ name: 'walletcardselect modal submit' })
}
